<template>
  <Layout @back="handleBackEvent">

    <MobileScreenManager :current="currentMobileScreen">
      <MobileScreen id="infos">
        <section class="fieldset scroller">
          <h3> {{ $t('users.informations') }}</h3>

          <form class="form">
            <div class="form-row">
              <label class="form-label hide-on-mobile" for="name">{{ $t('users.prenom') }} {{ $t('users.nom') }}</label>
              <input type="text" id="name" class="form-input" required v-model="selectedUserName"
                     name="nomprenom" v-validate
                     data-vv-rules="required" :data-vv-as="$t('users.prenom') +' '+$t('users.nom') "/>
              <label class="hide-on-desktop" for="name">{{ $t('users.prenom') }} {{ $t('users.nom') }}</label>
              <transition name="fade">
                                <span v-show="errors.has('nomprenom')" class="form-input-error"
                                      @click="hideError('nomprenom')">{{ errors.first('nomprenom') }}</span>
              </transition>
            </div>

            <div class="form-row">
              <label class="form-label hide-on-mobile" for="mail">{{ $t('users.email') }}</label>
              <input type="email" id="mail" class="form-input" required v-model="selectedUserEmail"
                     name="email" v-validate="'required|email'" @blur="testIfMailExists"/>
              <label class="hide-on-desktop" for="mail">{{ $t('users.email') }}</label>
              <transition name="fade">
                <span v-show="errors.has('email')" class="form-input-error"
                      @click="hideError('email')">{{ errors.first('email') }}</span>
              </transition>
            </div>

            <div class="form-row">
              <label class="form-label hide-on-mobile" for="phone">{{ $t('users.telephone') }}</label>
              <input type="tel" id="phone" class="form-input" required v-model="selectedUserPhone"/>
              <label class="hide-on-desktop" for="phone">{{ $t('users.telephone') }}</label>
            </div>

            <div class="form-row" :class="{disabled: editMode}">
              <label class="form-label hide-on-mobile" for="identifier">{{ $t('users.identifiant') }}</label>
              <input type="text" id="identifier" class="form-input" required v-model="selectedUserLogin"
                     name="identifier" v-validate="'required'"/>
              <label class="hide-on-desktop" for="identifier">{{ $t('users.identifiant') }}</label>
              <transition name="fade">
                                <span v-show="errors.has('identifier')" class="form-input-error"
                                      @click="hideError('identifier')">{{ errors.first('identifier') }}</span>
              </transition>
            </div>
            <Btn class="danger block" v-can="'admin-edit-users'" @click.native="handleUnblockAccount"
                 v-if="selectedUserIsLocked">{{ $t('users.unblockAccount') }}
            </Btn>
            <Btn class="primary block" v-can="'admin-edit-users'" @click.native="handleShowPasswordModal"
                 v-if="editMode">{{ $t('users.changeConnectionParameters') }}
            </Btn>
            <PasswordForm ref="passwordForm" :inline="true" :props="{}" v-if="!editMode"></PasswordForm>


            <Btn class="secondary block hide-on-desktop" @click.native="handleMobileAccess">{{ $t('users.accesManagement') }}
              <font-awesome-icon class="pull-right" icon="chevron-right"/>
            </Btn>
          </form>
          <div v-if="!isBeepizEnv">
            <hr v-if="customFields && customFields.length > 0"/>

            <h3 v-if="customFields && customFields.length > 0">Champs personnalisés</h3>
            <div v-if="customFields && customFields.length > 0" class="form">
              <div class="form-row" v-for="customField in customFields"
                   :class="{disabled:customField.visibility == 1}">
                <label class="form-label hide-on-mobile" :for="customField.field">{{
                    customField.label
                  }}</label>
                <input type="text" :id="customField.field" :name="customField.field"
                       class="form-input" v-validate="isRequired(customField.required)"
                       v-inputmask="convertMask(customField.mask)" required
                       v-model="selectedUser.customs['champ'+customField.field]"/>
                <label class="hide-on-desktop" :for="customField.field">{{ customField.label }}</label>
                <transition name="fade">
                                <span v-show="errors.has(customField.field)" class="form-input-error"
                                      @click="hideError(customField.field)">{{ errors.first(customField.field) }}</span>
                </transition>
              </div>
            </div>
          </div>
        </section>
      </MobileScreen>


      <MobileScreen id="access">
        <section class="fieldset universes-tabs">

          <div class="universes">
            <div
                :class="{active:hasRoleForUniverse(key),selected:universe.class == selectedUniverseClass,'not-selected':selectedUniverseClass != null && universe.class != selectedUniverseClass}"
                v-for="(universe,key,index) in universes" v-if="hasUniverse(key)"
                @click="handleAccessSelect(key)">
                            <span>
                                <component v-bind:is="universe.icon" :class="[universe.class]"></component>
                            </span>
              {{ universe.name }}
            </div>
          </div>
        </section>
      </MobileScreen>

      <MobileScreen id="rights">
        <section class="fieldset universe-config">
          <LoadingLight id="universeConfig"/>
          <UniverseConfigurator :definition="selectedUniverse" @change="handleConfigurationChange"
                                :class="{show:selectedUniverse}"></UniverseConfigurator>
          <div class="universe-helper" :class="{show:!selectedUniverse}">

            <h2>
              <font-awesome-icon icon="arrow-circle-up" size="2x"></font-awesome-icon>
              <br>
              {{ $t('users.univerSelection') }}
            </h2>
          </div>
        </section>
      </MobileScreen>
    </MobileScreenManager>

    <div slot="toolbarLeft">
      <Btn class="danger hide-on-mobile" v-can="'admin-delete-users'" @click.native="handleDelete"
           v-if="editMode">{{ $t('global.delete') }}
      </Btn>
    </div>

    <div slot="toolbar">

      <Btn class="primary mobile-block pull-right" v-can="'admin-edit-users'"
           :class="{disabled:(!hasModifications.infos && !hasModifications.access) && editMode}"
           @click.native="handleSave">
        {{ $t('global.save') }}
      </Btn>
      <Btn class="danger hide-on-desktop pull-left" v-can="'admin-delete-users'" @click.native="handleDelete"
           v-if="editMode">
        <font-awesome-icon icon="trash" style="margin: 0;"></font-awesome-icon>
      </Btn>
    </div>


  </Layout>
</template>

<script>


import Layout from '@l/BaseWithToolbar'
import LoadingLight from '@c/ui/LoadingLight'


import MobileScreenManager from '@c/ui/MobileScreenManager'
import MobileScreen from '@c/ui/MobileScreen'


import UniverseConfigurator from '@v/users/UniverseConfigurator'

import PasswordForm from '@v/users/PasswordForm'


import {mapGetters, mapMutations, mapActions, mapState} from 'vuex'

import _find from 'lodash/find'
import isEmail from 'validator/lib/isEmail'
import Utils from "../../services/utils";

export default {
  beforeCreate: function () {

  },
  beforeDestroy: function () {

  },
  beforeMount: function () {


  },
  beforeRouteLeave(to, from, next) {
    this.showLoading(true)
    setTimeout(() => {
      this.clearSelectedUser()
      next()
    }, 500)

  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteUpdate(to, from, next) {


    this.clearSelectedUser()
    next();
    if (this.$route.params.id) {
      const userPromise = this.fetchUser(this.$route.params.id);
      const rolesPromise = this.fetchRoles(this.$route.params.id);

      Promise.all([userPromise, rolesPromise])
          .then(() => {
            this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.form', {'username': this.selectedUser.name}))
            this.$store.commit('UI/backAction', 'historyBack')
            if (this.selectedUser.roles.length == 0) {
              this.addWarning('Cet utilisateur n\'a accès à aucun univers');
            }
            this.showLoading(false);
          })
    }
  },
  beforeUpdate: function () {

  },
  components: {
    Layout,
    LoadingLight,
    MobileScreenManager,
    MobileScreen,
    UniverseConfigurator,
    PasswordForm
  },
  computed: {
    isBeepizEnv() {
      //Si l'URL contient BEEPIZ ou marque grise (SFR, CATSAFE)
      return !Utils.isThemeSuivideflotte();
    },
    ...mapState({
      //selectedUserConfiguration: 'Users/selectedUserConfiguration'
      //selectedUser: 'Users/selectedUser',
    }),

    ...mapGetters({

      clientInfos: 'Papers/clientInfos'
      //selectedUserRoles: 'Users/selectedUserRoles',
      //selectedUserConfiguration: 'Users/selectedUserConfiguration'
    }),

    selectedUser: {
      get() {
        return this.$store.state.Users.selectedUser
      },
      set(value) {
        this.$store.commit('Users/selectedUser', value)
      }
    },

    selectedUserName: {
      get() {
        return this.$store.state.Users.selectedUser.name
      },
      set(value) {
        this.$store.commit('Users/selectedUserField', {field: 'name', value: value})
      }
    },

    selectedUserEmail: {
      get() {
        return this.$store.state.Users.selectedUser.email
      },
      set(value) {
        this.$store.commit('Users/selectedUserField', {field: 'email', value: value})
      }
    },

    selectedUserPhone: {
      get() {
        let phoneNumber = this.$store.state.Users.selectedUser.phone
        if (phoneNumber && phoneNumber.charAt(0) !== '0' && phoneNumber.charAt(0) !== '+') {
          return '+' + phoneNumber
        } else {
          return this.$store.state.Users.selectedUser.phone
        }
      },
      set(value) {
        this.$store.commit('Users/selectedUserField', {field: 'phone', value: value})
      }
    },

    selectedUserLogin: {
      get() {
        return this.$store.state.Users.selectedUser.login
      },
      set(value) {
        this.$store.commit('Users/selectedUserField', {field: 'login', value: value})
      }
    },

    selectedUserIsLocked: {
      get() {
        return this.$store.state.Users.selectedUser.bloque
      },
      set(value) {
        this.$store.commit('Users/selectedUserField', {field: 'login', value: value})
      }
    },

    selectedUserRoles: {
      get() {
        return this.$store.state.Users.selectedUserRoles
      },
      set(value) {
        this.$store.commit('Users/selectedUserRoles', value)
      }
    },

    selectedUniverseClass() {
      if (this.selectedUniverse) {
        return this.selectedUniverse.class
      }
      return null
    },

    universes() {
      return Utils.themedUniverses();
    },

    editMode() {
      return this.$route.params.id
    },

    customFields() {
      if (this.clientInfos.customFields && this.clientInfos.customFields.user) {
        return this.clientInfos.customFields.user
      }
      return null
    }
  },
  created: function () {


  },
  data() {
    return {
      currentMobileScreen: 'infos',
      selectedUniverse: null,
      hasModifications: {
        infos: false,
        access: false
      }
    }
  },
  destroyed: function () {
    this.clearSelectedUser()
  },
  methods: {
    ...mapMutations({
      showLoadingLight: 'UI/showLoadingLight',
      showLoading: 'UI/showLoading',
      loadingProgress: 'UI/loadingProgress',
      showModal: 'UI/showModal',
      setModalParams: 'UI/setModalParams',
      backAction: 'UI/backAction',
      addSuccess: 'Messages/addSuccess',
      addInfo: 'Messages/addInfo',
      addWarning: 'Messages/addWarning',
      addError: 'Messages/addError',
      clearMessages: 'Messages/clearMessages',
      selectedUserAddId: 'Users/selectedUserAddId',
      clearSelectedUser: 'Users/clearSelectedUser',

    }),

    ...mapActions({
      fetchUser: 'Users/fetchUser',
      fetchRoles: 'Users/fetchRoles',
      createUser: 'Users/createUser',
      editUser: 'Users/editUser',
      deleteUser: 'Users/deleteUser',
      editRoles: 'Users/editRoles',
      editGroups: 'Users/editGroups',
      checkMailExists: 'Users/checkMailExists',
    }),

    handleMobileAccess() {
      this.currentMobileScreen = 'access'
    },

    handleAccessSelect(key) {
      if (this.selectedUniverse && this.selectedUniverse.class == this.universes[key].class) {
        this.showLoadingLight({id: 'universeConfig', show: true})
        setTimeout(() => {
          this.selectedUniverse = null;
          setTimeout(() => {
            this.showLoadingLight({id: 'universeConfig', show: false})
          }, 300)
        }, 300)
      } else {
        this.showLoadingLight({id: 'universeConfig', show: true})
        setTimeout(() => {
          this.currentMobileScreen = 'rights'
          this.selectedUniverse = this.universes[key];
        }, 500)
      }
    },

    handleUnblockAccount(){
      window.App.$refs.confirm.show({
        title:window.V.$i18n.t('users.modals.unblockAccount.unlock'),
        content: window.V.$i18n.t('users.modals.unblockAccount.unlock_text'),
        callbackYes: () => {
          this.selectedUser.isUnlock = true
          this.edit()
        }
      });
    },

    handleBackEvent() {
      if (this.currentMobileScreen == 'rights') {
        this.currentMobileScreen = 'access'
      } else {
        this.currentMobileScreen = 'infos'
      }

    },
    handleSave() {
      this.showLoading(true);
      this.loadingProgress(0);

      if (!this.editMode) {
        this.$refs.passwordForm.validateForm()
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.editMode) {
            this.edit()
          } else {
            this.save()
          }
        } else {
          //this.showAllErrors();
          this.showLoading(false);
        }


      }).catch(() => {
        //this.showAllErrors();
        this.showLoading(false);
      });


    },

    save() {
      if (this.hasModifications.infos === true) {
        this.loadingProgress(1);
        let user = this.transformUser(this.selectedUser);

        this.createUser({data: user})
            .then(response => {

              this.selectedUserAddId(response.data.message);
              if (this.hasModifications.access === true) {
                this.loadingProgress(34);
                this.editGroups()
                this.editRoles()
                    .then(responseRole => {
                      this.loadingProgress(67);
                      this.$router.replace({
                        name: 'usersForm',
                        params: {id: this.selectedUser.id}
                      }, () => {
                        const userPromise = this.fetchUser(this.$route.params.id);
                        const rolesPromise = this.fetchRoles(this.$route.params.id);

                        Promise.all([userPromise, rolesPromise])
                            .then(() => {
                              this.loadingProgress(100);
                              this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.form', {'username': this.selectedUser.name}))
                              this.$store.commit('UI/backAction', 'historyBack')
                              this.clearMessages()
                              this.addSuccess('L\'utilisateur a bien été créé.');
                              this.showLoading(false);
                            })
                            .catch(e => {
                              this.handleErrors(e);
                            })

                      });
                    })
                    .catch(e => {
                      this.handleErrors(e);
                    })
              } else {
                this.loadingProgress(50);
                this.$router.replace({name: 'usersForm', params: {id: this.selectedUser.id}}, () => {
                  const userPromise = this.fetchUser(this.$route.params.id);
                  const rolesPromise = this.fetchRoles(this.$route.params.id);

                  Promise.all([userPromise, rolesPromise])
                      .then(() => {
                        this.loadingProgress(100);
                        this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.form', {'username': this.selectedUser.name}))
                        this.$store.commit('UI/backAction', 'historyBack')
                        this.clearMessages()
                        this.addSuccess('L\'utilisateur a bien été créé.');
                        this.showLoading(false);
                      })
                      .catch(e => {
                        this.handleErrors(e);
                      })

                });
              }
            })
            .catch(e => {
              this.handleErrors(e);
            })
      }
    },

    edit() {
      if (this.hasModifications.infos === true) {
        this.loadingProgress(1);
        let user = this.transformUser(this.selectedUser);
        user.theme=Utils.getTheme()
        this.editUser({id: this.selectedUser.id, data: user })
            .then(response => {


              if (this.hasModifications.access === true) {

                this.loadingProgress(25);

                this.editGroups()

                this.editRoles()
                    .then(responseRole => {
                      this.loadingProgress(100);
                      this.clearMessages()
                      this.addSuccess(window.V.$i18n.t("users.modificationSaved"));

                      this.showLoading(false);
                    })
                    .catch(e => {
                      this.handleErrors(e);
                    })
              } else {
                this.loadingProgress(100);
                this.clearMessages()
                this.addSuccess(window.V.$i18n.t("users.modificationSaved"));
                this.showLoading(false);
              }
            })
            .catch(e => {
              this.handleErrors(e);
            })

      } else if (this.hasModifications.access === true) {
        this.loadingProgress(25);
        this.editGroups()

        this.editRoles()
            .then(responseRole => {
              this.loadingProgress(100);
              this.clearMessages()
              this.addSuccess(window.V.$i18n.t("users.modificationSaved"));
              this.showLoading(false);
            })
            .catch(e => {
              this.handleErrors(e);
            })
      }
    },

    handleErrors(e) {
      console.log(e);
      if (422 == e.response.status) {
        this.clearMessages()
        //console.error(e.response.data.message);
        Object.keys(e.response.data.message).map((objectKey) => {
          if (Array.isArray(e.response.data.message[objectKey])) {
            e.response.data.message[objectKey].forEach(item => {
              this.addError(item);
            })
          } else {
            this.addError(e.response.data.message[objectKey]);
          }

        })
        this.showLoading(false);
      }
    },

    handleDelete() {
      window.App.$refs.confirm.show({
        title: window.V.$i18n.t("users.titles.delete"),
        content: window.V.$i18n.t("users.titles.deleteConfirm"),
        callbackYes: () => {
          this.showLoading(true);
          this.deleteUser(this.selectedUser.id)
              .then(responseRole => {
                this.clearMessages()
                this.addSuccess(window.V.$i18n.t("users.titles.deleted"));
                this.$router.replace({name: 'usersList'})
              })
        }
      });

    },

    transformUser(user) {
      let userTransformed = {...user};

      delete userTransformed.connectionCounter;
      delete userTransformed.createdAt;
      delete userTransformed.id;
      delete userTransformed.lastConnectionAt;
      delete userTransformed.profile;
      if (this.editMode) {
        delete userTransformed.login;
        delete userTransformed.auth;
      }

      if (this.clientInfos.customFields && this.clientInfos.customFields.user) {
        userTransformed.customs = this.transformCustoms(userTransformed.customs)
      } else {
        delete userTransformed.customs;
      }

      return userTransformed;
    },

    transformCustoms(customs) {
      let tCustoms = {}

      for (let i = 0; i < this.clientInfos.customFields.user.length; i++) {
        if (customs['champ' + this.clientInfos.customFields.user[i].field] != null) {
          tCustoms['champ' + this.clientInfos.customFields.user[i].field] = customs['champ' + this.clientInfos.customFields.user[i].field]
        }
      }

      return tCustoms
    },

    hasUniverse(slug) {
      let result = _find(this.clientInfos.universes, o => {
        return o === slug
      })

      if (result) {
        return true;
      }
      return false;
    },

    hasRoleForUniverse(slug) {

      if (this.selectedUserRoles[slug] && this.selectedUserRoles[slug].length > 0) {
        return true;
      }
      return false;

    },

    handleConfigurationChange() {
      this.hasModifications.access = true;
    },

    handleShowPasswordModal() {
      this.setModalParams({
        title: window.V.$i18n.t("users.titles.modifyConnexionParameters"),
        component: PasswordForm,
        props: {
          user: this.selectedUser
        }
      })
      this.showModal();
    },

    isRequired(val) {
      if (val === true) {
        return 'required'
      } else {
        return ''
      }
    },

    hideError(field) {
      this.errors.remove(field);
    },

    convertMask(mask) {
      if (mask == '******99' && this.clientInfos.readonly_groups === true) {
        let finalMask = ''

        let tabMask = mask.split('');
        for (let i = 0; i < tabMask.length; i++) {
          if (tabMask[i] == '9') {
            finalMask += '(' + tabMask[i] + '|x|X)'
          } else {
            finalMask += tabMask[i]
          }
        }


        return finalMask
      } else {
        return mask
      }


    },

    testIfMailExists() {
      if (isEmail(this.selectedUserEmail)) {
        this.checkMailExists(this.selectedUserEmail)
            .then(response => {
              if (response.data === true) {
                this.addWarning(window.V.$i18n.t("users.errors.sameMail"))
              }
            })
      }
      /*this.showLoading(true);
      setTimeout(() => {
          this.loadingProgress(50)
      },1000)*/
    }

  },
  mounted: function () {

    if (this.$route.params.id) {
      const userPromise = this.fetchUser(this.$route.params.id);
      const rolesPromise = this.fetchRoles(this.$route.params.id);

      Promise.all([userPromise, rolesPromise])
          .then(() => {
            this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.form', {'username': this.selectedUser.name}))
            this.$store.commit('UI/backAction', 'historyBack')
            if (this.selectedUser.roles.length == 0 && !sessionStorage.getItem('AS_CLIENT')) {
              this.addWarning(window.V.$i18n.t("users.errors.userNotUnivers"));
            }
            this.showLoading(false);
          })
    } else {

      this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.formNew'))
      this.$store.commit('UI/backAction', 'historyBack')
      this.showLoading(false);
    }

  },
  name: 'UsersForm',
  props: {},
  updated: function () {
    //this.showLoading(false);
    /*this.clearSelectedUser()*/
    /*if(this.$route.params.id){
        const userPromise = this.fetchUser(this.$route.params.id);
        const rolesPromise = this.fetchRoles(this.$route.params.id);

        Promise.all([userPromise,rolesPromise])
            .then(() => {
                this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.form', {'username': this.selectedUser.name}))
                this.$store.commit('UI/backAction', 'historyBack')

            })
    }*/

  },
  watch: {
    currentMobileScreen(newVal, oldVal) {

      if (window.getComputedStyle(document.getElementById('mobileHelper'), null).getPropertyValue('display') != 'none') {
        if (newVal == 'infos') {
          this.backAction('emitEvent')
        }

        switch (newVal) {
          case 'infos':
            this.backAction('historyBack')
            break;
          case 'access':
          case 'rights':
            this.backAction('emitEvent')
            break;
        }
      } else {
        this.backAction('historyBack')
      }


    },
    'selectedUser.name'(newVal, oldVal) {
      if (oldVal) {
        this.hasModifications.infos = true;
      }
      if (!this.$route.params.id) {
        this.selectedUser.login = newVal.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/ /g, '.').toLowerCase()
      }


    },
    'selectedUser.email'(newVal, oldVal) {
      if (oldVal != null) {
        this.hasModifications.infos = true;
      }

    },
    'selectedUser.phone'(newVal, oldVal) {
      if (oldVal != null) {
        this.hasModifications.infos = true;
      }

    },
    'selectedUser.login'(newVal, oldVal) {
      if (oldVal != null) {
        this.hasModifications.infos = true;
      }

    },
    'selectedUser.customs'(newVal, oldVal) {
      if (oldVal != null) {
        this.hasModifications.infos = true;
      }

    }
  }
}
</script>

<style lang="scss">

.universe-helper {

  $alpha: 0.2;

  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  color: rgba($main-black, $alpha);
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100%;
  opacity: 0;
  transition: opacity 300ms ease-out;
  pointer-events: none;


  h2 {

    margin: 0;
    text-align: center;

    .fa-arrow-circle-up {
      display: inline-block;
      margin-bottom: 20px;
    }
  }

  &.show {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/users/Form.vue